import React from "react";
import { getVoteStats } from "./vote-utils";

export const ElectionDayCardSmall = ({ data, name }: any) => {
    const { total, voted, notVoted } = getVoteStats(data);

    const partyData = data?.gotv_party || {};

    return (
        <div className="rounded-xl border bg-white p-4 shadow-sm transition hover:shadow-md">
            <div className="text-sm text-gray-400">Booth</div>
            <div className="text-lg font-bold">{name}</div>

            <div className="mt-4 grid grid-cols-3 text-center">
                <div>
                    <div className="text-xs text-gray-400">Total</div>
                    <div className="font-bold">{total}</div>
                </div>

                <div>
                    <div className="text-xs text-gray-400">Polled</div>
                    <div className="font-bold text-green-600">{voted}</div>
                </div>

                <div>
                    <div className="text-xs text-gray-400">Not Voted</div>
                    <div className="font-bold text-red-600">{notVoted}</div>
                </div>
            </div>

            {/* Party */}
            <div className="mt-3 border-t pt-2 text-xs">
                {Object.entries(partyData).map(([k, v]) => (
                    <div key={k} className="flex justify-between">
                        <span>{k}</span>
                        <span>{v as number}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};
